// extracted by mini-css-extract-plugin
export default {"form-section":"Form_form-section__115JV","form":"Form_form__yLbbb","fieldset":"Form_fieldset__eMXUf","address":"Form_address__g4f9C"};